export default __webpack_public_path__ + "static/media/complex-layout-3.881a9eab.png";